import getValueWithUnit from 'lib/getValueWithUnit';
import { currencyUnits } from 'lib/units';

export const getBaseFeeValue = (baseFee: string | null) => {
  if (!baseFee) {
    return null;
  }
  const valGwei = getValueWithUnit(baseFee, 'gwei');
  if (valGwei.isGreaterThanOrEqualTo(0.0001)) {
    return `${ valGwei.toFormat(4) } ${ currencyUnits.gwei }`;
  }
  return `${ getValueWithUnit(baseFee, 'wei').toFormat() } ${ currencyUnits.wei }`;
};

export const formatToEllipsis = (str: string, ellipsisLength: number = 8, ellipsisPart: number = 2): string => {
  const parts = str.trim().split(' ');
  let numberPart = parts[0]; // The numeric part
  const currency = parts.length > 1 ? parts.slice(1).join(' ') : ''; // Token symbol if present

  // Remove all non-numeric characters except the decimal point for digit counting
  const digitsOnly = numberPart.replace(/\D/g, '');

  if (digitsOnly.length > ellipsisLength) {
    if (numberPart.includes('.')) {
      const [ integer, decimal ] = numberPart.split('.');
      numberPart = `${integer}.${decimal.slice(0, ellipsisPart)}...${decimal.slice(-ellipsisPart)}`;
    } else {
      numberPart = `${digitsOnly.slice(0, ellipsisPart)}...${digitsOnly.slice(-ellipsisPart)}`;
    }
  }

  return currency ? `${numberPart} ${currency}` : numberPart;
};

export const needsEllipsis = (str: string, ellipsisLength: number = 8): boolean => {
  const numberPart = str.trim().split(' ')[0]; // Extract the number part
  const digitsOnly = numberPart.replace(/\D/g, ''); // Count only numeric characters

  return digitsOnly.length > ellipsisLength;
};
